interface DeptBadgeProps {
  dept?: string;
  deptRole?: string;
  /** 추가 클래스 (정렬 보정 등) */
  className?: string;
}

// 분과 배지에 직책까지 함께 노출하는 직책 목록
const LEAD_ROLES = ["위원장", "부위원장"];

/**
 * 회원 «분과» 배지.
 * - dept 가 비면 배지를 만들지 않는다(null).
 * - dept_role 이 «위원장/부위원장» 이면 배지 안에 함께 표시한다.
 *   예) [재단위원회 위원장]
 * - 색은 연회색 배경 + 진한 회색 글자 (club_role 배지보다 약하게).
 * - 카드/목록/메인 명함 섹션에서 공통으로 사용한다.
 */
export default function DeptBadge({ dept, deptRole, className = "" }: DeptBadgeProps) {
  const name = String(dept ?? "").trim();
  if (!name) return null;

  const role = String(deptRole ?? "").trim();
  const showRole = LEAD_ROLES.includes(role);

  return (
    <span
      className={`inline-block max-w-full whitespace-nowrap rounded-full bg-background-100 px-2.5 py-0.5 text-[11px] font-medium text-foreground-600 ${className}`}
    >
      {name}
      {showRole && <span className="ml-1 font-semibold text-foreground-700">{role}</span>}
    </span>
  );
}